import React, { memo, useRef } from 'react';
import PropTypes from 'prop-types';
import PictionJS from 'piction-js';
import { connect } from 'react-redux';
import { useDrag, useDrop } from 'react-dnd';
import appConfig from '../../appConfig';
import { disableRightClick } from '../../utils/uiUtils';
// knight
const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  dispatch: actionToDispatch => dispatch(actionToDispatch),
});

// todo: refactor. remove isNotJustified, use classNameModifier -- i.e. same as workspace preview
function UMOSortItem({ umo, customMetatag, onMoveItem }) {
  // set up references for drag and drop
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'UMO', id: umo.id, position: umo.data.ob && umo.data.ob[0] },
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  let url;
  const img = document.createElement('img');
  img.src = './images/images.png';

  // TODO: Should be able to retrieve tsize without using _data
  if (parseInt(umo.thumbnail._data.$.tsize) !== 0) {
    url = umo.thumbnail.url;
  } else {
    switch (umo.type) {
      case 'AUDIO':
        url = './images/thumb/audio.jpg';
        break;
      case 'DOCUMENT':
        url = './images/thumb/document.jpg';
        break;
      case 'RELATIONAL':
        url = './images/thumb/relational.gif';
        break;
      case 'PHOTO':
        url = './images/thumb/image.jpg';
        break;
      case 'VIDEO':
        url = './images/thumb/video.jpg';
        break;
      default:
        url = './images/thumb/img_nothumb.gif';
        break;
    }
  }

  let customMeta = '';
  if (customMetatag) {
    const customTag = umo.metadataList.getMetadata(customMetatag);
    if (customTag && customTag.value) {
      customMeta = <span className={`umo-grid-item--customIcon ${customTag.value}`} />;
    }
  }

  const thumbWidth = umo.data.w[0] === '0' ? 200 : umo.data.w[0];
  const thumbHeight = umo.data.h[0] === '0' ? 200 : umo.data.h[0];
  const imageTag =
    (<img
      alt=""
      className="image"
      src={url}
      width={thumbWidth}
      height={thumbHeight}
      onContextMenu={disableRightClick}
    />);

  const titleMetatag = appConfig.sortItemMetatag &&
    ((umo.tombstoneMetadataList.getMetadata(appConfig.sortItemMetatag) &&
        umo.tombstoneMetadataList.getMetadata(appConfig.sortItemMetatag).value) ||
      (umo.metadataList.getMetadata(appConfig.sortItemMetatag) &&
        umo.metadataList.getMetadata(appConfig.sortItemMetatag).value
      ));
  const title = titleMetatag || umo.name;

  const opacity = isDragging ? 0.5 : 1;
  const containerStyle = { opacity };

  return (
    <div className="umo-sort-item-noj" ref={drag} style={containerStyle}>
      <i className="umo-sort__grip-icon" />
      <div className="umo-sort-item entry-visible umo-sort-item--noj">
        {customMeta}
        {imageTag}
      </div>
      <div className="umo-sort-item-info">
        <li key={umo.id} className="umo-sort-item-info__item">
          {title}
        </li>
      </div>
    </div>
  );
}

UMOSortItem.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO).isRequired,
  customMetatag: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(UMOSortItem);
